module.exports = __webpack_public_path__ + "img/jj.cd4cb9f7.png";